import Vue from "vue";
import App from "./App.vue";
import VueLazyload from "vue-lazyload";
import Meta from "vue-meta";
import checkView from "vue-check-view";
import VueI18n from "vue-i18n";
import router from "./router/router";
import VueAnalytics from "vue-analytics";

import {
    CONFIG
} from "@/lib/config";
import {
    HTTP,
    CancelToken
} from "@/lib/api";
import en from "@/lang/en.json";
import zh from "@/lang/zh.json";
import BootstrapVue from "bootstrap-vue";
import {
    VueMasonryPlugin
} from "vue-masonry";

Vue.use(BootstrapVue);
Vue.use(VueMasonryPlugin);
Vue.config.productionTip = false;
Vue.prototype.$debug = process.env.NODE_ENV === "development";
Vue.prototype.$config = CONFIG;
Vue.prototype.$http = HTTP;
Vue.prototype.CancelToken = CancelToken;

Vue.prototype.isExternalLink = function (link) {
    if (link && link.startsWith("http")) {
        if (process.env.NODE_ENV === "development") {
            return !link.startsWith("http://osc.scmp.com");
        }
        return true;
    }
    return false;
};

Vue.prototype.getDataValue = function (key, data) {
    let value = null;
    if (data) {
        value = localStorage.locale == "en" ? data[key] : data[key + "_cht"];
        if (!value || value == "") {
            value = data[key] || data[key + "_cht"];
        }
    }
    return value;
};
Vue.prototype.filterHTML = function (html) {
    return html.replace(/(\.\.\/)+assets\/media/g, process.env.VUE_APP_API_URL + "/assets/media");
};
Vue.prototype.getAssetLink = function (link) {
    if (link) {
        if (!link.startsWith("http") && !link.startsWith("//")) {
            if (!link.startsWith("/")) {
                link = "/" + link;
            }
            link = process.env.VUE_APP_API_URL + link;
        }
        link = link.replace(/\s/g, "%20");
    }
    return link;

    // if (!link || link == "") return null;
    // if (link.startsWith('uploads/') || link.startsWith('media/')) {
    //     link = process.env.VUE_APP_API_URL + "/" + link;
    //     return link;
    // }
    // // if (process.env.NODE_ENV == "development") { // TEMP
    // //     if (link.startsWith('/images/')) {
    // //         link = link.replace("/images/", "http://osc.scmp.com/images/");
    // //         return link;
    // //     }
    // //     if (link.startsWith('/photos/')) {
    // //         link = link.replace("/photos/", "http://osc.scmp.com/photos/");
    // //         return link;
    // //     }
    // // }
    // if (link && link.startsWith('http')) {
    //     return link;
    // }
    // if (!link.startsWith('/')) {
    //     link = "/" + link;
    // }
    // return process.env.VUE_APP_API_URL + link;
};
Vue.prototype.scrollTo = function (selector) {
    var elements = document.querySelectorAll(selector);
    if (elements && elements.length > 0) {
        elements[0].scrollIntoView({
            inline: "start",
            block: "start",
            behavior: "smooth"
        });
        // var top = elements[0].offsetTop;
        // window.scrollTo({
        //     scrollTop: top,
        //     behavior: 'smooth',
        // });
    }
};
Vue.use(VueLazyload, {
    error: "/images/spacer.png",
    loading: "/images/ajax-loader.gif",
    filter: {
        progressive(listener) {
            let link = listener.el.getAttribute("src");
            if (link && !link.startsWith("/images/")) { // Skip Lazy load and add base url to the image links in body html
                if (!link.startsWith("http") && !link.startsWith("//")) {
                    if (!link.startsWith("/")) {
                        link = "/" + link;
                    }
                    link = link.replace(/\.\.\//g, "");
                    link = process.env.VUE_APP_API_URL + link;
                }
                // listener.src = link;
                listener.src = listener.loading = link;
                listener.el.setAttribute("lazy-progressive", "true");
            }
        }
    }
});
Vue.use(Meta);
Vue.use(checkView);
Vue.use(VueI18n);
Vue.use(require("vue-moment"));
Vue.use(VueAnalytics, {
    id: "UA-6891676-22",
    // id: 'UA-141197391-1',
    router,
    // autoTracking: {
    //     pageviewOnLoad: false
    // }
});

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: (localStorage.locale) ? localStorage.locale : CONFIG.default_locale,
    fallbackLocale: CONFIG.default_locale,
    messages: {
        en: en,
        zh: zh
    }
});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount("#app");

// change missing handler
i18n.missing = function (locale, key) {
    if (key) {
        if (key.startsWith("page.")) {
            return "";
        } else if (key.startsWith("component.form.")) {
            return key.replace("component.form.", "");
        }
    }
    return key;
};